import { Route, Routes } from 'react-router-dom';

import Layout from '@/components/globals/Layout';
import PrivateRoute from '@/components/globals/PrivateRoute';
import RedirectOldUrlRouter from '@/components/globals/RedirectOldUrlRouter';
import RedirectRouter from '@/components/globals/RedirectRouter';
import ScrollToTop from '@/components/globals/ScrollToTop';
import Certificates from '@/pages/Certificates';
import Content from '@/pages/Content';
import Course from '@/pages/Course';
import Help from '@/pages/Help';
import Invite from '@/pages/Invite';
import Lesson from '@/pages/Lesson';
import MyCourses from '@/pages/MyCourses';
import Notes from '@/pages/Notes';
import Notifications from '@/pages/Notifications';
import Portals from '@/pages/Portals';
import Profile from '@/pages/Profile';
import Resume from '@/pages/Resume';
import SavedLessons from '@/pages/SavedLessons';
import Unsubscribe from '@/pages/Unsubscribe';
import accounts from '@/services/accounts';
import * as tokenService from '@/services/token';

function AppRoutes() {
  tokenService.checkIsAuthenticated();
  const hasAccountsToken = new URLSearchParams(window.location.search).has('accounts_token');

  if (hasAccountsToken) {
    accounts.loginAccounts();
  }

  return (
    <ScrollToTop>
      <Routes>
        {/* public routes */}
        <Route path='/' element={<Layout />}>
          <Route path='/curso/:hash/:slug?' element={<Course />} />
          <Route path='/curso/:hash/:slug?/aula/:id' element={<Lesson />} />
          <Route path='/unsubscribe/:trackId' element={<Unsubscribe />} />
          <Route path='/' element={<RedirectRouter />} />
        </Route>

        <Route
          path='/cadastro/:hash'
          element={
            <PrivateRoute register={true}>
              <RedirectRouter />
            </PrivateRoute>
          }
        />

        {/* private routes */}
        <Route
          path='/'
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path='/conteudo/:courseHash/:lessonId?' element={<Content />} />
          <Route path='/convite/:courseHash/:inviteId' element={<Invite />} />
          <Route path='/resumo' element={<Resume />} />
          <Route path='/certificados' element={<Certificates />} />
          <Route path='/cursos' element={<MyCourses />} />
          <Route path='/portais' element={<Portals />} />
          <Route path='/aulas/salvas' element={<SavedLessons />} />
          <Route path='/notas' element={<Notes />} />
          <Route path='/notificacoes' element={<Notifications />} />
          <Route path='/ajuda' element={<Help />} />
          <Route path='/perfil' element={<Profile />} />
        </Route>

        {/* redirect routes */}
        <Route path='/v3/*' element={<RedirectOldUrlRouter />} />
        <Route path='/*' element={<RedirectRouter />} />
      </Routes>
    </ScrollToTop>
  );
}

export default AppRoutes;
